// extracted by mini-css-extract-plugin
export default {"about":"About_about__XhZdl","title":"About_title__0V5G9","headerWrapper":"About_headerWrapper__qz6+x","text":"About_text__voh6f","textBox":"About_textBox__zBSE6"};